const labels = [
    {
      name: "high",
      text: "HIGH",
      color: "issueHigh",
      value: 1,
    },
    {
      name: "medium",
      text: "MEDIUM",
      color: "issueMedium",
      value: 2,
    },
    {
      name: "low",
      text: "LOW",
      color: "issueLow",
      value: 3
    },
    {
      name: "info",
      text: "INFO",
      color: "issueInfo",
      value: 4
    },
  ]

function getLabelText(str) {
    if (typeof str === "string") {
        return labels.find(({ name }) => name === str.toLowerCase()).text;
    }
}

function getLabelColor(str) {
    if (typeof str === "string") {
        return labels.find(({ name }) => name === str.toLowerCase()).color;
    }
}

// TODO Get vueapexcharts to use the vuetify theme defs if possible
const chartColorArray = ["#c62828", "#f57c00", "#827717", "#1e88e5"]

export { getLabelText, getLabelColor, chartColorArray }